import { Button } from "./styles/Button.styled";
import ReactModal from "react-modal";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";
import {
  ModalBody,
  ModalClose,
  PlanDocLink,
  RenewalFeaturesRow,
  RenewalPlanDetailBottom,
  RenewalPlanDetailContent,
  RenewalPlanDetailDocs,
  RenewalPlanDetailFacts,
  RenewalPlanDetailInfo,
  RenewalPlanDetailPriceTable,
  RenewalPlanDetailPriceTbody,
  RenewalPlanDetailPriceThead,
  RenewalPlanEbillLabel,
  RenewalPlanInfo,
  RenewalPlanLabel,
  RenewalPlanNameRow,
  RenewalPlanPriceLabel,
  RenewalPlanPriceLeft,
  RenewalPlanRow,
} from "./styles/Product.styled";
import NumberFormat from "react-number-format";
import "react-tooltip/dist/react-tooltip.css";
import { getBgColor } from "../utils";

export const ProductDetailModal = ({
  show,
  data,
  handleGoEnroll,
  handleClose,
}: {
  show: boolean;
  data: any;
  handleGoEnroll: Function;
  handleClose: Function;
}) => {
  const { t } = useTranslation("modal");
  
  const content = () => {
    if (!data) return null;
    const {
      name,
      kwh0500Price,
      kwh1000Price,
      kwh2000Price,
      productDocuments,
      contractLengthName,
      contractPeriodName,
      productDisplayShortDescription,
      productDisplayFeature5,
      rawCommodityPrice,
    } = data;

    const rateType = productDisplayShortDescription.split(",")[1];

    return (
      <RenewalPlanDetailContent>
        <RenewalPlanDetailInfo>
          <RenewalPlanDetailPriceTable>
            <RenewalPlanDetailPriceThead>
              <span>{t("averageMonthlyUsage")}</span>
              <span>{t("pricePerKwh")}</span>
            </RenewalPlanDetailPriceThead>
            <RenewalPlanDetailPriceTbody>
              <div>
                <span>500 kWh</span>
                <NumberFormat
                  displayType={"text"}
                  value={kwh0500Price}
                  decimalScale={1}
                  fixedDecimalScale={true}
                  suffix="¢"
                />
              </div>
              <div>
                <span>1,000 kWh</span>
                <NumberFormat
                  displayType={"text"}
                  value={kwh1000Price}
                  decimalScale={1}
                  fixedDecimalScale={true}
                  suffix="¢"
                />
              </div>
              <div>
                <span>2,000 kWh</span>
                <NumberFormat
                  displayType={"text"}
                  value={kwh2000Price}
                  decimalScale={1}
                  fixedDecimalScale={true}
                  suffix="¢"
                />
              </div>
            </RenewalPlanDetailPriceTbody>
            <p style={{ fontSize: 10, color: '#666', marginTop: 10 }}>{t("averagePricesDisclaimer")}</p>
          </RenewalPlanDetailPriceTable>
          <h4>{t("planDocuments")}</h4>
          <RenewalPlanDetailDocs>
            {productDocuments.map((docVal: any, docIdx: number) => (
              <PlanDocLink
                href={docVal.documentURL}
                target="_blank"
                key={docIdx}
              >
                {docVal.documentName}
              </PlanDocLink>
            ))}
          </RenewalPlanDetailDocs>
        </RenewalPlanDetailInfo>
        <RenewalPlanDetailFacts>
          <RenewalPlanNameRow>
            <h4>{name}</h4>
            {productDisplayFeature5 && (
              <RenewalPlanLabel
                style={{
                  backgroundColor: getBgColor(productDisplayFeature5).bg,
                  border: `1px solid ${getBgColor(productDisplayFeature5).border}`,
                  padding: "5px 2rem",
                }}
              >
                {productDisplayFeature5}
              </RenewalPlanLabel>
            )}
          </RenewalPlanNameRow>
          <RenewalPlanPriceLeft>
            <RenewalPlanPriceLabel>{t("averagePrice")}</RenewalPlanPriceLabel>
            <div>
              <div>
                <b>
                  <NumberFormat
                    displayType={"text"}
                    value={kwh2000Price}
                    decimalScale={1}
                    fixedDecimalScale={true}
                  />
                </b>
                <i>¢</i>
              </div>
              <span className="kwh-label">{t("at2000kWh")}</span>
            </div>
            <span>{t("basedOn")} {rawCommodityPrice}¢ {t("energyRate")}</span>
          </RenewalPlanPriceLeft>
          {
            // isEbillRequired &&
            <RenewalPlanEbillLabel>
              <img src="/images/alert-circle.png" width="16" alt="" />
              <span
                data-tooltip-id="ebill-tooltip"
                data-tooltip-content={t("ebillingTooltip")}
                style={{ cursor: 'pointer' }}
              >
                {t("requiresEbilling")}
              </span>
              <Tooltip id="ebill-tooltip" />
            </RenewalPlanEbillLabel>
          }
          <RenewalPlanInfo>
            {rateType && (
              <RenewalPlanRow>
                <label>
                  <img src="/assets/icons/2026/icon_Lock.svg" width="35" alt="" />
                  {t("planType")}
                </label>
                <span className="upper1Letter">{rateType}</span>
              </RenewalPlanRow>
            )}
            <RenewalPlanRow>
              <label>
                <img src="/assets/icons/2026/icon_Calender.svg" width="35" alt="" />
                {t("planLength")}
              </label>
              <span>{`${
                contractPeriodName === "Years"
                  ? parseInt(contractLengthName) * 12
                  : contractLengthName
              } ${t("months")}`}</span>
            </RenewalPlanRow>
            <RenewalPlanRow>
              <label>
                <img src="/assets/icons/2026/icon_Cancel.svg" width="35" alt="" />
                {t("cancelFee")}
              </label>
              <span>{t("cancelFeeAmount")}</span>
            </RenewalPlanRow>
            <RenewalPlanRow>
              <label>
                <img src="/assets/icons/2026/icon_Discount.svg" width="35" alt="" />
                {t("monthlyFee")}
              </label>
              <span>{t("monthlyFeeAmount")}</span>
            </RenewalPlanRow>
            {/* <RenewalPlanRow>
              <label>
                <img
                  src="/assets/icons/2026/icon_Discount.svg"
                  width="35"
                  alt=""
                />
                Monthly fee:
              </label>
              <span>$4.95</span>
            </RenewalPlanRow> */}
          </RenewalPlanInfo>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Button
              onClick={() => {
                handleGoEnroll(data);
                handleClose();
              }}
            >
              {t("selectPlan")}
            </Button>
          </div>
        </RenewalPlanDetailFacts>
      </RenewalPlanDetailContent>
    );
  };

  return (
    <ReactModal
      isOpen={show}
      closeTimeoutMS={110}
      onRequestClose={() => handleClose()}
      shouldCloseOnOverlayClick={true}
      style={{
        content: {
          maxWidth: "900px",
          margin: "0 auto",
          top: "50% !important",
          left: "50% !important",
          right: "auto !important",
          bottom: "auto !important",
          transform: "translate(-50%, -50%) !important",
          maxHeight: "90vh",
          overflow: "hidden",
          position: "fixed",
          padding: "44px 0 0 0",
          borderRadius: "30px",
        },
        overlay: {
          overflow: "auto",
        },
      }}
    >
      <ModalBody>
        {content()}
        <RenewalPlanDetailBottom>
          <h4>{t("planIncludes")}</h4>
          <RenewalFeaturesRow>
            <div>
              <i>
                <img src="assets/icons/2026/icon_Discount.svg" alt="" width="36" />
              </i>
              <h4>{t("straightforwardPricing")}</h4>
              <p>{t("straightforwardPricingDesc")}</p>
            </div>
            <div>
              <i>
                <img src="assets/icons/2026/icon_Pets.svg" alt="" width="36" />
              </i>
              <h4>{t("freePetBenefits")}</h4>
              <p>{t("freePetBenefitsDesc")}</p>
            </div>
          </RenewalFeaturesRow>
          <RenewalFeaturesRow>
            <div>
              <i>
                <img src="assets/icons/2026/icon_Hearts.svg" alt="" width="36" />
              </i>
              <h4>{t("communityImpact")}</h4>
              <p>{t("communityImpactDesc")}</p>
            </div>
            <div>
              <i>
                <img src="assets/icons/2026/icon_Save.svg" alt="" width="36" />
              </i>
              <h4>{t("toolsToSave")}</h4>
              <p>{t("toolsToSaveDesc")}</p>
            </div>
          </RenewalFeaturesRow>
        </RenewalPlanDetailBottom>
      </ModalBody>
      <ModalClose onClick={() => handleClose()} />
    </ReactModal>
  );
};
